import { createElement, useState, useEffect, useCallback, useImperativeHandle, useRef, } from 'react';
import * as React from 'react';
import { Table, Loading, Collapse, Drawer, Dialog } from '@alifd/next';
import { ProTableSettingContext } from '../contexts/pro-table-setting-context';
import { ProTableFilterContext } from '../contexts/pro-table-filter-context';
import EditForm from './components/edit-from';
import Operations from './components/operations';
import request from '@/utils/request';
import { nanoid } from 'nanoid';
import Pagination from './components/pagination';
import { useActionColumnProps } from './hooks';
import Filter from '../components/column-filters';
import ColumnCell from '../components/column-cell';
import './index.scss';
import { RunDrawer } from './components/business';
import { isEmpty } from 'lodash-es';
export const modalBusinessComponent = [
    {
        title: '运行详情',
        value: 'accountBussinessRun',
        Component: RunDrawer,
    },
];
const EditTable = (props, ref) => {
    const [loading, setLoading] = useState(false);
    const [dataSouece, setDataSource] = useState([]);
    const [pageParams, setPageParams] = useState({
        pageSize: 10,
        pageNo: 1,
    });
    const [total, setTotal] = useState(0);
    const [tableSetting, setTableSetting] = useState({
        isZebra: true,
        size: 'medium',
        crossline: false,
    });
    const [whereCondition, setWhereCondition] = useState([]);
    const [fieldMap, setFieldMap] = useState({});
    const [editType, setEditType] = useState('create');
    const [editRow, setEditRow] = useState({});
    const [collapseKeys, setCollapseKeys] = useState(['1']);
    const [widths, setWidths] = useState({});
    const [rowRecord, setRowRecord] = useState({});
    const [visible, setVisible] = useState(false);
    const [behavior, setBehavior] = useState({});
    const autoRequestRef = useRef(true);
    const paramsRef = useRef({});
    const { columns = [], actionColumnProps, indexColumn, settingButtons, actionBarButtons, rowSelection, __designMode, formBlocks, editable, title, field, changingField, addButtonformBlocks = [], controlledPane = false, autoRequest = true, onRowClick, } = props;
    const url = `/api${props?.url?.split('?')?.[0]?.split('/api')?.[1]}`;
    const isDesign = __designMode === 'design';
    useEffect(() => {
        if (autoRequest === false) {
            autoRequestRef.current = false;
        }
    }, [autoRequest]);
    useEffect(() => {
        if (controlledPane) {
            setCollapseKeys([]);
        }
    }, [controlledPane]);
    const openPane = (keys) => {
        setCollapseKeys(keys);
    };
    const formProps = {
        formBlocks,
        __designMode,
    };
    const getList = useCallback(async () => {
        setLoading(true);
        try {
            const { content = [], page: { total }, fieldMap = {}, } = await request.get(url, {
                params: {
                    ...pageParams,
                    ...paramsRef.current,
                    whereCondition: encodeURI(JSON.stringify(whereCondition)),
                },
            });
            setDataSource(content);
            setTotal(total);
            setFieldMap(fieldMap);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }, [pageParams, url, whereCondition]);
    const formatDataSource = (dataSouece) => {
        return dataSouece?.map((item) => ({ ...item, uid: nanoid() }));
    };
    const onPageChange = (pageParams) => {
        if (isDesign)
            return;
        setPageParams((state) => ({
            ...state,
            ...pageParams,
        }));
    };
    useEffect(() => {
        if (isDesign)
            return;
        if (url && autoRequestRef.current) {
            getList();
        }
    }, [getList, isDesign, url]);
    const scollToEditForm = useCallback(() => {
        if (isDesign)
            return;
        const last = document.querySelectorAll('.next-collapse-panel.next-collapse-panel-expanded').length - 1;
        document
            .querySelectorAll('.next-collapse-panel.next-collapse-panel-expanded')?.[last]?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }, [isDesign]);
    const refreshList = (params) => {
        if (params) {
            paramsRef.current = params;
            autoRequestRef.current = true;
        }
        getList();
    };
    const operationsProps = {
        settingButtons,
        actionBarButtons,
        isDesign,
        editable,
        openPane,
    };
    const onResizeChange = (dataIndex, value) => {
        const __widths = { ...widths };
        __widths[dataIndex] += value;
        setWidths(__widths);
    };
    const initWidths = useCallback(() => {
        const widths = {};
        columns.forEach(({ dataIndex }) => {
            widths[dataIndex] = 100;
        });
        setWidths(widths);
    }, [columns]);
    useEffect(() => {
        initWidths();
    }, [initWidths]);
    const onExpand = (keys) => {
        openPane(keys);
    };
    useEffect(() => {
        if (collapseKeys.length === 2) {
            scollToEditForm();
        }
    }, [collapseKeys, scollToEditForm]);
    const __actionColumnProps = useActionColumnProps({
        ...actionColumnProps,
        isDesign,
        setEditType,
        setEditRow,
        url,
        openPane,
        refreshList,
        setRowRecord,
        setVisible,
        addButtonformBlocks,
        setBehavior,
        onRowClick,
    });
    const handleCancel = () => {
        setVisible(false);
    };
    const renderModal = () => {
        const type = behavior?.type;
        if (type === 'drawer') {
            const foundComponent = modalBusinessComponent.find((item) => item.value === behavior?.drawerBussinessType);
            const Components = foundComponent?.Component;
            const fundProps = {
                rowRecord,
            };
            return (createElement(Drawer, { placement: "right", visible: visible, onClose: handleCancel, width: "80%" }, isEmpty(foundComponent) ? null : createElement(Components, { ...fundProps })));
        }
        if (type === 'dialog') {
            return (createElement(Dialog, { v2: true, title: "", visible: visible, onOk: handleCancel, onClose: handleCancel },
                createElement("p", null, type)));
        }
        return null;
    };
    useImperativeHandle(ref, () => ({ refreshList, setCollapseKeys }));
    return (createElement(ProTableSettingContext.Provider, { value: {
            tableSetting,
            setTableSetting,
            setEditType,
            refreshList,
            setEditRow,
            setRowRecord,
            setVisible,
            setBehavior,
        } },
        createElement(ProTableFilterContext.Provider, { value: { whereCondition, setWhereCondition, fieldMap } },
            createElement("div", { ref: ref, className: "edit-table" },
                createElement(Loading, { visible: loading },
                    createElement(Collapse, { expandedKeys: collapseKeys, onExpand: onExpand },
                        createElement(Collapse.Panel, { title: title, key: '1', disabled: isDesign ? false : controlledPane },
                            createElement(Operations, { ...operationsProps }),
                            createElement("div", { className: "table-wrap" },
                                createElement(Table.StickyLock, { ...tableSetting, rowSelection: rowSelection, dataSource: formatDataSource(dataSouece), primaryKey: "uid", onResizeChange: onResizeChange, tableLayout: "fixed" },
                                    indexColumn && (createElement(Table.Column, { title: "\u5E8F\u53F7", lock: "left", align: "center", width: 70, cell: (value, index) => (createElement("div", { className: "fusion-ui-tablex-serial-number" }, index + 1)) })),
                                    columns.map(({ dataIndex, title, formatType, searchable, formatOptions, dict, type, ...rest }) => {
                                        const filterProps = {
                                            title,
                                            formatType,
                                            dataIndex,
                                            dict,
                                            type,
                                        };
                                        const width = widths[dataIndex];
                                        return (createElement(Table.Column, { ...rest, width: width, key: dataIndex, asyncResizable: true, dataIndex: dataIndex, title: searchable ? createElement(Filter, { ...filterProps }) : title, cell: (value, rowIndex, record) => {
                                                const cellProps = {
                                                    value,
                                                    rowIndex,
                                                    record,
                                                    formatType,
                                                    formatOptions,
                                                    dict,
                                                    type,
                                                };
                                                return createElement(ColumnCell, { ...cellProps });
                                            } }));
                                    }),
                                    actionColumnProps?.showActionColumn && (createElement(Table.Column, { ...__actionColumnProps, lock: "right" })))),
                            createElement(Pagination, { onChange: onPageChange, total: total }),
                            visible ? renderModal() : null),
                        editable && (createElement(Collapse.Panel, { title: `${title}配置`, key: "2", disabled: !isDesign },
                            createElement(EditForm, { ...formProps, url: url, editType: editType, editRow: editRow, openPane: openPane, refreshList: refreshList, field: field, changingField: changingField })))))))));
};
const EditTableRef = React.forwardRef(EditTable);
export default EditTableRef;
